import LSPUserData from './LSPUserData';

export default LSPUserData;
